<template>
  <v-container  fluid class="pa-0 dark-bg">
    <v-row no-gutters justify="center">
      <v-col cols="12" sm="10" md="8" lg="6"
        
      >
      <v-card class="elevated-card" transparent>
        <v-card v-for="candidate in candidates" light
        :key="candidate.id"
          class="pa-5"
          max-width="380"
          elevation="4"
          style="border-radius: 20px;"
        >

          <v-row no-gutters>
            <!-- Avatar -->
            <v-col cols="3" class="d-flex justify-center">
              <v-avatar size="70" tile>
                <v-img
                  :src="candidate.gender=='A' ? require('@/assets/girl.jpg') : require('@/assets/boy2.jpeg')"
                  class="elevation-2"
                  style="background-color: #A259FF; border-radius: 20px;"
                ></v-img>
              </v-avatar>
            </v-col>

            <!-- Info -->
            <v-col cols="9" class="pl-4">
              <h3 :style="{ color: candidate.gender == 'A' ? 'orange' : 'purple' }" class="font-weight-bold mb-1">{{ candidate.gender == 'A' ? 'Kelin' : 'Kuyov' }}</h3>
              <p style="font-size:14px" class="grey--text mb-0">{{candidate.marital_status.name}}</p>
              <p style="font-size:14px" class="grey--text mb-0">{{candidate.profession}}</p>
            </v-col>
          </v-row>

          <!-- Stats & Button -->
          <v-row class="mt-2" align="center">
            <v-col cols="4" class="text-center">
              <v-icon color="purple">mdi-cake-variant-outline</v-icon>
              <h6 class="mb-0 font-weight-bold"> {{ candidate.age }} </h6>
            </v-col>

            <v-col cols="4" class="text-center">
              <v-icon color="purple">mdi-human-male-height</v-icon>
              <h6 class="mb-0 font-weight-bold"> {{ candidate.height }} </h6>
            </v-col>
            
            <v-col cols="4" class="text-center">
              <v-icon color="purple">mdi-weight-kilogram</v-icon>
              <h6 class="mb-0 font-weight-bold">{{ candidate.weight }}</h6>
              
            </v-col>
          </v-row>
        </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Candidates',
  data() {
    return {
      defaultPhoto: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
      candidates: []
    }
  },
  methods: {
    async getMyCandidates() {
      this.loading = true;
      try {
        const res = await axios.get(
          this.$store.state.backend_url + "api/my-candidates"
        );
        this.candidates = res.data;
        // this.resetForm();/
      } catch (error) {
        alert("Xatolik: " + error.message);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getMyCandidates();
  },
}
</script>

<style scoped>
.v-card {
  border-radius: 16px;
  transition: 0.3s ease;
}
.v-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
</style>
